<template>
  <div class="panel-item ">
    <div class="title_name" style="display: flex; justify-content: space-between;">
      <div>仓库信息</div>
    </div>
<!--    <div ref="chartContainer" style="width: 100%; height: calc(100% - 45px);"></div>-->
  </div>
</template>

<script>
import * as echarts from 'echarts';
import 'echarts-gl';
import flightData from './flightData.json'; // 导入JSON文件
import worldData from './world.json'; // 导入JSON文件


export default {
  props: {},
  data() {
    return {
      chart: null,

      data: flightData
    }
  },
  mounted() {
    this.initChart();
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  },
  watch: {},
  methods: {
    initChart() {
      // 初始化图表
      this.chart = echarts.init(this.$refs.chartContainer);

      echarts.registerMap("world", worldData);


      // 修正：使用箭头函数保持 this 上下文
      let routes = this.data.routes.map((airline) => {
        return [this.getAirportCoord(airline[1]), this.getAirportCoord(airline[2])];
      });

      // 设置初始空图表配置
      const option = {
        geo3D: {
          map: 'world',
          shading: 'realistic',
          silent: true,
          environment: '#333',
          realisticMaterial: {
            roughness: 0.8,
            metalness: 0
          },
          postEffect: {
            enable: true
          },
          groundPlane: {
            show: false
          },
          light: {
            main: {
              intensity: 1,
              alpha: 30
            },
            ambient: {
              intensity: 0
            }
          },
          viewControl: {
            distance: 70,
            alpha: 89,
            panMouseButton: 'left',
            rotateMouseButton: 'right'
          },
          itemStyle: {
            color: '#000'
          },
          regionHeight: 0.5
        },
        series: [
          {
            type: 'lines3D',
            coordinateSystem: 'geo3D',
            effect: {
              show: true,
              trailWidth: 1,
              trailOpacity: 0.5,
              trailLength: 0.2,
              constantSpeed: 5
            },
            blendMode: 'lighter',
            lineStyle: {
              width: 0.2,
              opacity: 0.05
            },
            data: routes
          }
        ]
      }

      this.chart.setOption(option);

      // 监听窗口大小变化，自适应图表
      window.addEventListener('resize', this.handleResize);
    },
    getAirportCoord(idx) {
      return [this.data.airports[idx][3], this.data.airports[idx][4]];
    },


    handleResize() {
      if (this.chart) {
        this.chart.resize();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.panel-item {
  width: 490px;
  height: 420px;
  background: url(../../assets/_s-image_sector_bg.png) no-repeat;
  background-size: 100% 100%;

  .title_name {
    padding: 30px 0 23px 100px;
    font-weight: 400;
    font-size: 22px;
    color: #FFFFFF;
  }
}
</style>
